import React from 'react';
import { Sidebar } from './components/Sidebar';
import { LyricsView } from './components/LyricsView';
import { RightSidebar } from './components/RightSidebar';
import { MediaPlayer } from './components/MediaPlayer';
export function App() {
  return <div className="flex flex-col h-screen bg-black text-white" data-id="element-0">
      <div className="flex flex-1 overflow-hidden" data-id="element-1">
        <Sidebar data-id="element-2" />
        <LyricsView data-id="element-3" />
        <RightSidebar data-id="element-4" />
      </div>
      <div className="bg-[#181818] border-t border-[#282828]" data-id="element-5">
        <MediaPlayer title="It Happened Quiet" artist="AURORA" albumArt="https://i.scdn.co/image/ab67616d00001e02fb13ebe958ca179eb115789c" currentTime="0:07" duration="4:09" progress={3} isPlaying={true} volume={0.7} data-id="element-6" />
      </div>
      <div className="bg-[#1DB954] text-xs text-black py-1 px-4 flex items-center" data-id="element-7">
        <div className="flex items-center" data-id="element-8">
          <span className="mr-2" data-id="element-9">
            <svg height="16" width="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-10">
              <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z" data-id="element-11"></path>
              <path d="M8 3.25a.75.75 0 0 1 .75.75v3.25H11a.75.75 0 0 1 0 1.5H7.25V4A.75.75 0 0 1 8 3.25z" data-id="element-12"></path>
            </svg>
          </span>
          Playing on LAPTOP-VE7KK0CD
        </div>
      </div>
    </div>;
}